import { useEffect } from 'react';

// Module-level ref count (not per-hook-instance) so two locks open at once —
// e.g. a confirm dialog opened from inside an already-locked review panel —
// don't have the first one to unmount prematurely restore `overflow` while
// the other is still active.
let lockCount = 0;
let previousOverflow: string | null = null;

/**
 * Locks page scroll (document.body) while `active` is true — standard modal/
 * drawer behavior (Radix Dialog/Sheet already does this internally; this hook
 * is for panels that portal themselves directly instead of going through
 * Radix, e.g. ScriptReviewPanel) so the background page/table isn't
 * independently scrollable — and doesn't show its own scrollbar — while a
 * panel is open on top of it.
 */
export function useBodyScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    if (lockCount === 0) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    lockCount++;
    return () => {
      lockCount--;
      if (lockCount === 0) {
        document.body.style.overflow = previousOverflow ?? '';
      }
    };
  }, [active]);
}
